import { takeEvery } from 'redux-saga';
import { take, put, call } from 'redux-saga/effects';

import { loadDataAction,loadDataDoneAction, loadDataErrorAction } from 'modules/app/actions';
import { getGoods } from '../actions';
import { GET_GOODS } from '../constants/actionTypes';
import * as api from '../repository';


function *_fetchGoods(action) {
    const {trac} = action;
    yield put(loadDataAction('goods'));
    try {
        const goods =  yield call(api.getGoods(trac));
        yield put(getGoods.success({goods, utrac:trac}));
        yield put(loadDataDoneAction('goods'));
    } catch (error) {
        yield put(getGoods.error(error));
        yield put(loadDataErrorAction('goods', {response: error.response}, action));
    }
}

export function *fetchGoods() {
    yield takeEvery(GET_GOODS.REQUEST, _fetchGoods);
}
